import { z } from 'zod';

export function slugify(name: string) {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

export function workspaceSlugify(name: string): string {
  return slugify(name).substring(0, 12).replace(/-+$/, '');
}

export const slugSchema = z
  .string()
  .min(1, 'URL Name is required')
  .max(63, 'Max 63 characters')
  .regex(/^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/, {
    message: 'Lowercase letters, numbers, and hyphens only',
  });

export const workspaceSlugSchema = z
  .string()
  .min(1, 'URL Name is required')
  .max(12, 'Max 12 characters')
  .regex(/^[a-z]([a-z0-9-]*[a-z0-9])?$/, {
    message: 'Must start with a letter; lowercase letters, numbers, and hyphens only',
  });

export const displayNameSchema = z.string().min(1, 'Name is required');

export const workspaceDisplayNameSchema = z
  .string()
  .min(1, 'Name is required')
  .regex(/^[a-zA-Z][a-zA-Z0-9 ]*$/, {
    message: 'Must start with a letter and contain only letters, numbers, and spaces',
  });
